<template>
  <div class="developer-menu p-0">

     <el-button class="btn-block" type="danger" size="small" @click="onClickDeployTargetInfo" style="text-align: left; font-size: 12pt; line-height: 14pt;">
      Production Code: <strong>{{is_production ? 'YES' : 'NO'}}</strong><br />
      Deploy Target: <strong>{{deploy_target}}</strong>
    </el-button>

    <!--
    <router-link class="el-dropdown-menu__item" to="/dev/ressource-dag">DEV: Ressource DAG</router-link>
    <router-link class="el-dropdown-menu__item" to="/dev/timeline">DEV: Timeline</router-link>
    -->
    <router-link class="el-dropdown-menu__item" to="/dev/generic-api">Admintool: Generic API</router-link>
    <router-link class="el-dropdown-menu__item" to="/dev/optimizer">Development Optimizer</router-link>

    <div class="dropdown-divider"></div>

    <div class="el-dropdown-menu__item">
      <el-checkbox :value="SHOW_DEBUG" @input="onClickShowDebug">Show Debug Ouput ({{SHOW_DEBUG}})</el-checkbox>
    </div>

    <div class="el-dropdown-menu__item">
      <el-checkbox :value="$store.state.app.debugtool.show" @input="onClickShowDebugBar">Show Optimizer Debug-Tool</el-checkbox>
    </div>
    <div class="el-dropdown-menu__item">
      <el-checkbox :value="!$store.state.app.disable_optimizer" @input="onClickEnableOptimizer">Enable Optimizer</el-checkbox>
    </div>
    <el-button class="btn-block" @click="onShowOnboardingWizard">Show Onboarding</el-button>
    <div class="dropdown-divider">DEV</div>
    <router-link class="el-dropdown-menu__item" to="/experiments">Experiments</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/elements">Experiments - Elements</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/tz">Experiments - Timezone</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/tz-moment">Experiments - Moment Timezone</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/i18n">Experiments - i18n</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/gantt">Experiments - Gantt</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/tooltip">Experiments - Tooltips</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/tiles">Experiments - VB Tiles</router-link>
    <router-link class="el-dropdown-menu__item" to="/experiments/masonry">Experiments - Masonry</router-link>
    <div class="d-flex">
      <el-input
        class="mr-1"
        size="small"
        prepend="Timer"
        type="number"
        :number="true"
        v-model="timerValue">
      </el-input>
      <el-button size="small" @click="onStartTimer">Start</el-button>
    </div>
    <div class="dropdown-divider"></div>
    DRAFT:
    <router-link class="m-1" to="/draft/daily-checklist">WIP: Daily Checklist</router-link> |
    <router-link class="m-1" to="/draft/lanes">lanes</router-link> |
    <router-link class="m-1" to="/draft/kanban/:goalId">kanban</router-link> |
    <router-link class="m-1" to="/draft/goal/:goalId">goal</router-link> |
    <router-link class="m-1" to="/draft/timeslot">timeslot</router-link> |
    <router-link class="m-1" to="/draft/calendar">calendar</router-link> |
    <router-link class="m-1" to="/draft/session/:sessionId">session</router-link> |
    <router-link class="m-1" to="/draft/focus/">focus</router-link> |
    <router-link class="m-1" to="/draft/user/:userId">user</router-link> |
    <router-link class="m-1" to="/draft/projects">LEGACY: Projects</router-link> |
    <router-link class="m-1" to="/draft/timeslot">LEGACY: Old Timeslot Page</router-link>
  </div>
</template>

<script>

export default {
  data() {
    return {
      is_production: process.env.VUE_APP_PRODUCTION !== "false",
      deploy_target: process.env.VUE_APP_DEPLOY_TARGET,
      timerValue: "25",
    };
  },
  methods: {
    onClickDeployTargetInfo() {
      let info = Object.keys(process.env).map(key => {
        return `${key}: ${process.env[key]}`;
      }).join('\n\n')
      alert(info)
    },

    onStartTimer() {
      this.$router.push({ path: `/draft/eggtimer/${this.timerValue}` });
    },

    onClickShowDebug(value) {
      this.$store.commit('app/SET_DEBUG', value);
    },

    onClickEnableOptimizer(value) {
      this.$store.commit('app/SET_OPTIMIZER_DISABLE', !value);
    },

    onClickShowDebugBar(value) {
      this.$store.commit('app/TOGGLE_DEBUGBAR');
    },

    onShowOnboardingWizard() {
      this.$root.showUpdateModal('init-setup');
    }
  }
}
</script>

<style>
.el-popover.nav-menu-popover .developer-menu .el-dropdown-menu__item {
  height: 30px;
  line-height: 30px;
}
</style>
